// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d8881cd2","453":"6d19991b","667":"fde5c1e0"}[chunkId] + ".chunk.js";
};